import axiosVerbose from '../utils/axios/axiosVerbose'
import { logError } from '../utils/errors'
import menusConfigs from '../../config/sites/menus'

let CACHED_STATS = null

export const fetchStats = ({
  apiUrlPrefix
}) => {
  return (dispatch, getState) => {
    const state = getState()
    if (state.common.stats) {
      return
    }

    if (CACHED_STATS) {
      return dispatch({
        type: 'receiveStats',
        payload: CACHED_STATS
      })
    }

    return axiosVerbose.get(`${apiUrlPrefix}/shopfront_api/stat`)
      .then((response) => {
        CACHED_STATS = response.data

        return dispatch({
          type: 'receiveStats',
          payload: response.data
        })
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        return dispatch({
          type: 'receiveStatsError',
          error: true
        })
      })
  }
}

export const setCurrentSite = (currentSite) => {
  return {
    type: 'setCurrentSite',
    payload: currentSite
  }
}

export const setBaseUrl = (baseUrl) => {
  return {
    type: 'setBaseUrl',
    payload: baseUrl
  }
}

export const setMenuConfig = (currentSite) => {
  return {
    type: 'setMenuConfig',
    payload: menusConfigs[currentSite] || []
  }
}

export const showAlert = (message, type = 'warning', canBeDismissed = true) => {
  return {
    type: 'showAlert',
    payload: {
      message,
      type,
      canBeDismissed
    }
  }
}

export const hideAlert = (message) => {
  return {
    type: 'hideAlert',
    payload: {
      message
    }
  }
}

export const resetAlerts = () => {
  return {
    type: 'resetAlerts'
  }
}

export const setErrorPage = (id) => {
  return {
    type: 'setErrorPage',
    payload: {
      id
    }
  }
}

export const resetErrorPage = () => {
  return {
    type: 'resetErrorPage'
  }
}

export const noIndex = () => {
  return {
    type: 'noIndex'
  }
}

export const setSeoMeta = ({title, meta_description}) => {
  return {
    type: 'setSeoMeta',
    payload: {
      title,
      meta_description
    }
  }
}



// WEBPACK FOOTER //
// ./common/actions/common.js